import React, { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Button, Modal } from "components"
import { closeShift } from "services"
import classes from "./ScsShiftIsAlreadyOpenModal.module.scss"
import clsx from "clsx"

const ScsShiftIsAlreadyOpenModal = (props) => {
  const {
    alreadyOpenShiftId,
    openShiftIsAlreadyOpenModal,
    setOpenShiftIsAlreadyOpenModal
  } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const handleCloseShift = async () => {
    setSending(true)

    try {
      await closeShift(
        alreadyOpenShiftId,
        { diffrence: 0, actualCashAmount: 0 }
      )

      if (unmount.current) return

      setOpenShiftIsAlreadyOpenModal(false)

      toast.success(
        t("شیفت_با_موفقیت_بسته_شد_می_توانید_شیفت_جدید_خود_را_شروع_کنید"), { autoClose: false }
      )
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات_انجام_نشد"))

      if (unmount.current) return

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openShiftIsAlreadyOpenModal}
      backdrop="static"
      onExited={() => setSending(false)}
    >
      <div className={classes["container"]}>
        <h4 className={classes["title"]}>
          ⚠️⚠️⚠️
          <br />
          {t("کاربر_محترم")}
          <br />
          {t("شیف_مورد_نظر_در_دستگاه_دیگری_باز_می_باشد_در_صورت_اقدام_به_بستن_شیف_دستگاه_مربوطه_از_شیف_خارج_می_شود_و_شیف_جدید_در_این_دستگاه_آغاز_می_شود")}
        </h4>

        <div className={classes["footer"]}>
          <Button
            color="danger"
            disabled={sending}
            className={clsx(classes["yes"], isLtr && classes["yes-ltr"])}
            onClick={() => setOpenShiftIsAlreadyOpenModal(false)}
          >
            {t("لغو")}
          </Button>

          <Button
            color="success"
            loading={sending}
            onClick={handleCloseShift}
          >
            {t("بستن_شیفت_قبلی")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ScsShiftIsAlreadyOpenModal